import { Button, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import styles from './ChangingAllPage.module.scss';
import FormRegisterOne from '../../components/ui/FormRegisterOne/FormRegisterOne';
import useHousingStockHousesState from '../../hooks/useHousingStockHousesState';
import { filteredHousesRegistration } from '../../utils/filteredHousesRegistration';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentHousesRegister } from '../../store/actions/housingStockActions';
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min';
import BtnRegistration from '../../components/common/BtnRegistration/BtnRegistration';
import useChangeTemplateModalVisible from '../../hooks/useChangeTemplateModalVisible';
import cn from 'classnames';
import {
  HandleItemChangeContext,
  HousesContext,
  HousesFilterContext,
  SelectedItemsContext,
  HandleSelectAllChangeContext,
  HandleSelectAllHousesContext,
} from './Provider';

const ChangingAllPage = () => {
  const location = useLocation();
  const history = useHistory();

  const {
    housingStockHousesState: { data: houses, isFetching: isHousesFetching },
  } = useHousingStockHousesState();

  const currentCompany = useSelector(
    (state) => state.housingStockStore.currentCompany
  );

  const [housesFilter, setHousesFilter] = useState('');
  const [selectedItems, setSelectedItems] = useState(houses);

  useEffect(() => {
    let filter = '';

    if (houses?.length > 0) {
      filter = filteredHousesRegistration(houses);
    }
    if (location?.state?.houses) {
      setSelectedItems(location.state.houses);
      setHousesFilter(filter);
    } else {
      setSelectedItems(houses);
      setHousesFilter(filter);
    }
  }, [houses]);

  const handleItemChange = (item) => {
    setSelectedItems((prevSelected) =>
      prevSelected.find((selected) => selected.houseId === item.houseId)
        ? prevSelected.filter((selected) => selected.houseId !== item.houseId)
        : [...prevSelected, item]
    );
  };

  const handleSelectAllChange = (group, isChecked) => {
    const groupItems = housesFilter[group];
    setSelectedItems((prevSelected) => {
      const groupIds = groupItems.map((item) => item.houseId);
      if (isChecked) {
        return [
          ...prevSelected,
          ...groupItems.filter((item) =>
            prevSelected.every((selected) => selected.houseId !== item.houseId)
          ),
        ];
      } else {
        return prevSelected.filter(
          (selected) => !groupIds.includes(selected.houseId)
        );
      }
    });
  };

  const handleSelectAllHouses = (isChecked) => {
    const selectHouses = [];
    if (isChecked) {
      Object.values(housesFilter).forEach((street) => {
        street.forEach((house) => selectHouses.push(house));
      });
    }
    setSelectedItems(selectHouses);
  };

  const dispatch = useDispatch();
  const { open } = useChangeTemplateModalVisible();

  const openModal = () => {
    dispatch(setCurrentHousesRegister(selectedItems));
    open(selectedItems);
  };

  const cancellationCancel = () => {
    history.push(`/HousingStock/company/${currentCompany?.id}/houses`);
  };

  return (
    <Spin spinning={isHousesFetching}>
      <div className={styles.container}>
        <header className={styles.header}>
          <div className={styles.block}>
            <h2 className={styles.title}>Изменить режим регистрации</h2>
            <p className={styles.step}>Шаг 1/2</p>
          </div>
          <div style={{ display: 'flex', gap: '20px' }}>
            <BtnRegistration
              text="Отменить"
              onClick={cancellationCancel}
            />
            <Button
              type="primary"
              onClick={openModal}
              disabled={!selectedItems || selectedItems?.length === 0}
              className={cn(
                styles.btnOpenModal,
                selectedItems &&
                  selectedItems.length > 0 &&
                  styles.btnOpenModalOn,
                (!selectedItems || selectedItems.length === 0) &&
                  styles.btnOpenModalDisabled
              )}
            >
              Сохранить и продолжить
            </Button>
          </div>
        </header>
        <HousesContext.Provider value={houses}>
          <HousesFilterContext.Provider value={housesFilter}>
            <SelectedItemsContext.Provider value={selectedItems}>
              <HandleItemChangeContext.Provider value={handleItemChange}>
                <HandleSelectAllChangeContext.Provider
                  value={handleSelectAllChange}
                >
                  <HandleSelectAllHousesContext.Provider
                    value={handleSelectAllHouses}
                  >
                    <FormRegisterOne />
                  </HandleSelectAllHousesContext.Provider>
                </HandleSelectAllChangeContext.Provider>
              </HandleItemChangeContext.Provider>
            </SelectedItemsContext.Provider>
          </HousesFilterContext.Provider>
        </HousesContext.Provider>
      </div>
    </Spin>
  );
};

export default ChangingAllPage;
